import createProductLayout from './createProductLayout';
import Illustration from './illustration/Illustration';
import Header from './header/Header';
import Body from './body/Body';
import ReadMore from './read-more/ReadMore';
import ButtonContainer from './cta-components/ButtonContainer';
import { standardGrid } from './styles';
const ProductLayout = createProductLayout({
  coreComponents: {
    Illustration,
    Header,
    Body,
    ReadMore,
    Cta: ButtonContainer
  },
  defaultGrid: standardGrid
});
export default ProductLayout;
//# sourceMappingURL=ProductLayout.js.map